export const initialModal = () => ({
  title: "Spot the Odd One Out!",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title">
        Welcome to <strong>The Vision Challenge!</strong>
      </div>
      <div className="modal-description-contents">
        <p>
          In each level, one box has a slightly different shade. Your task is to
          click the one that looks different.
        </p>
        <p>
          But here’s the twist — colors are hidden! You’ll only see them when
          you hover (or tap and hold on mobile), and even then, just a small
          area around your cursor is revealed.
        </p>
      </div>
      <div className="modal-description-footer">
        Can you identify the odd box in every level?
      </div>
    </div>
  ),
  buttonText: "Start",
  buttonType: "start",
});

export const levelPassedModal = (level) => ({
  title: "Well Done!",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title" />
      <div className="modal-description-contents">
        <p>
          You found the different box in{" "}
          <span className="highlight-blue">Level {level}</span>. Ready for Level{" "}
          {level + 1}?
        </p>
      </div>
    </div>
  ),
  buttonText: level < 5 ? "Next" : "Start",
  buttonType: "start",
});

export const completionModal = () => ({
  title: "Champion of Vision!",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title" />
      <div className="modal-description-contents">
        <p>
          Amazing! You've completed all levels and proven your sharp vision.
        </p>
      </div>
    </div>
  ),
  buttonText: "Play Again",
  buttonType: "start",
});
